import React, { Component } from "react";
import BloxButton from "sub_components/Common/BloxButton";
import TicketNumberDefault from "sub_components/Common/TicketNumberDefault";

class ConfirmationPage extends Component {
  goToTicket = (ticketNumber) => {
    const { navigate } = this.props;
    navigate(`/portal/support/ticket_history/support/${ticketNumber}`);
  };
  componentDidMount() {
    setTimeout(() => {
      try {
        const ticket = document.getElementById("ticket-confirmation-stage");
        const ticketConfirmation = document.getElementById(
          "prefix__Gradient_Ticket_Fill-2"
        );
        document.getElementById("ticket-confirmation-trans").beginElement();
        ticketConfirmation.classList.add("active");
        if (ticket) {
          ticket.classList.add("active");
        }
      } catch (e) {
        console.log(e);
      }
    }, 1000);
  }

  render() {
    const { closeModal, ticketResponse } = this.props;

    let createError = false;
    const caseId = ticketResponse.data?.caseId;

    if (
      (!ticketResponse.error && caseId) ||
      (ticketResponse?.data?.error &&
        ticketResponse.data.error ===
          "Ticket was created but there was an error saving file attachments.")
    ) {
    } else {
      createError = true;
    }
    const title = createError
      ? "Something went wrong."
      : "You've successfully opened a new ticket.";
    const subTitle = createError
      ? "Looks like something went wrong on our end.Please try again. If the problem persists please call 877-590-1684 "
      : "Please allow 24-48 hours for us to review your request.";
    return (
      <div className="ticket-confirmation-stage" id="ticket-confirmation-stage">
        <div className="ticket-number-wrapper">
          <div
            className="ticket-container"
            onClick={
              caseId
                ? () => {
                    this.goToTicket(caseId);
                  }
                : () => {}
            }
          >
            <div className="default">
              {" "}
              {!createError && ticketResponse.status === 200 && caseId && (
                <TicketNumberDefault number={caseId} />
              )}
            </div>
          </div>
        </div>
        <div className="text-wrapper">
          <div className="confirmation-title header20">{title}</div>
          <div className="confirmation-subtitle body20">{subTitle}</div>
        </div>
        <div className="done-button">
          <BloxButton
            title="DONE!"
            enabled={true}
            customClass="blox-button purple-gradient"
            onClick={closeModal}
          />
        </div>
      </div>
    );
  }
}

export default ConfirmationPage;
